import { gql_request, GqlRequestOptions } from '@common/api-request';

import * as types from './kill-switch_types.2';

export function getIsFeatureEnabled(variable: types.GetIsFeatureEnabledVariables, options?: GqlRequestOptions) {
  const query = 'query GetIsFeatureEnabled($key_name: String!) { isFeatureEnabled(feature: $key_name) }';
  return gql_request<types.GetIsFeatureEnabled, types.GetIsFeatureEnabledVariables>('GetIsFeatureEnabled', query, variable, { use_consumer: true, ...options });
}
